import {useStatements} from '@/biz/statement.mjs'

const iterStatementWithHotkey = function* (statements) {
    for (const s of statements) {
        if (s.children) {
            yield* iterStatementWithHotkey(s.children)
        }
        else if (
            s.statementMacShortcutKey ||
            s.statementWinShortcutKey ||
            s.statementContent
        ) {
            yield s
        }
    }
}

const makeCallback = stmt => function () {
    const {
        commands: {canInsertStatement, insertStatement},
        selectedNodes,
    } = this

    const nodes = canInsertStatement(selectedNodes, stmt)

    if (0 < nodes.length) {
        insertStatement(nodes, stmt)
    }
}

export default () => {
    const statements = useStatements()
    const hotkeys = {}

    for (const s of iterStatementWithHotkey(statements)) {
        if (s.statementMacShortcutKey) {
            hotkeys[s.statementMacShortcutKey] = makeCallback(s)
        }

        if (s.statementWinShortcutKey) {
            hotkeys[s.statementWinShortcutKey] = makeCallback(s)
        }
    }

    return hotkeys
}
